<div class="modal-header flex-fill">
    <h3 class="modal-title d-flex justify-content-between" style="font-size: 18px; font-weight: 400;" cvLocalizedText
        langSection="Pipeline_Configuration" langKey="Component_Filter_Fields">Filter Fields
    </h3>
    <button type="button" class="modal-close icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="CloseModal()">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
        </svg>
    </button>
</div>
<div class="filter-modal-body modal-body" >
    <div style="width:662px;" class="mx-6 mt-3"><cxone-spinner style="left: 45%; position: relative;"
            [isSpinner]="isLoading"></cxone-spinner>
        <button *ngIf="!isLoading" class="cxone-btn btn-big btn-secondary btn-bg-is-white"
            (click)="addFilterField()"  [disabled]="!checkNewFilter()" cvLocalizedText langSection="CXOne_Manage_Metrics"
            langKey="Add_Filter_Field_Button">Add
            Filter Field</button>
        <ng-container *ngIf="!isLoading">
            <ng-container *ngFor="let selection of selectionsList; let FFIndex = index; let first = first;">
                <div *ngIf="!first" class="add-line">
                    <span *ngIf="FFIndex > 1" cvLocalizedText langSection="Pipeline_Configuration" langKey="Component_Multiple_Filters_AND">
                      AND
                    </span>
                  </div>
                  
                <div class="d-flex filter-header">
                    <div style="width: 100%">{{getFilterHeading(FFIndex)}}</div>
                    <div><svg (click)="onTrashClick(FFIndex)" class="icon-16 cursor-hover">
                            <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                        </svg></div>
                </div>
                <div class="filter-body">
                    <div class="d-flex w-100">
                        <div class="w-50">
                            <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                                {{getLocalizationStringUpper("Data_Field","Data Field")}}
                                <span class="required-field">* &nbsp;</span>
                            </div>
                            <cxone-singleselect-dropdown #datafield style="width: 302px;"
                                [ngModel]="selection?.DataField"
                                [placeholder]="getLocalizationString('Select_Item', 'Select...')"
                                [options]="DataFieldList" [primaryKey]="'label'" [label]="'label'"
                                (ngModelChange)="dataFieldChange($event, FFIndex)" ngDefaultControl
                                (dropdownOpened)="onSelOpened(datafield)" (dropdownClosed)="onSelClosed(datafield);"
                                [showFooter]="DataFieldList.length > 10"
                                [search]="DataFieldList.length > 10"></cxone-singleselect-dropdown>
                        </div>
                        <div class="w-50" style="margin-left: 16px;">
                            <div class="color-no2Pencil font-size-12 mb-1 font-weight-bold">
                                {{getLocalizationStringUpper("Operator","Operator")}}
                                <span class="required-field">* &nbsp;</span>
                            </div>
                            <cxone-singleselect-dropdown #operator style="width: 302px;"
                                [options]="selection?.OperatorList" [ngModel]="selection?.Operator" [label]="'value'"
                                [placeholder]="getLocalizationString('Select_Item', 'Select...')" [primaryKey]="'key'"
                                ngDefaultControl (dropdownOpened)="onSelOpened(operator)"
                                (dropdownClosed)="onSelClosed(operator);" [showFooter]="OperatorList.length > 10"
                                [search]="OperatorList.length > 10"
                                (ngModelChange)="onOperatorChange($event, FFIndex)"></cxone-singleselect-dropdown>
                        </div>
                    </div>
                    <div>
                        <div *ngIf="selection.ValueList.length > 0"
                            class="color-no2Pencil font-size-12 mb-1 mt-4 font-weight-bold">
                            {{getLocalizationStringUpper("Value","Value")}}
                            <span class="required-field">* &nbsp;</span>
                        </div>
                        <div [ngStyle]="{'margin-top': first ? '0px' : '20px'}"
                            *ngFor="let comp of selection.ValueList; let count = count; let last = last; let compindex = index; let first = first; trackBy: trackByIndex"
                            class="d-flex">
                            <div style="width: 302px;height:35px;" *ngIf="selection.DataField?.ExpectedType == 0">
                                <cxone-singleselect-dropdown #value style="width: 302px;"
                                    [ngModel]="selection?.ValueList[compindex]"
                                    [placeholder]="getLocalizationString('Select_Item', 'Select...')" [label]="'name'"
                                    [primaryKey]="'name'" [options]="selection.DistinctDataValuesDDL"
                                    [showFooter]="selection.DistinctDataValuesDDL.length > 10" [search]="true"
                                    [enableAddFreeTextItem]="true" (onCreate)="addTextItem($event, compindex, FFIndex)"
                                    (dropdownOpened)="onSelOpened(value)" (dropdownClosed)="onSelClosed(value);"
                                    (ngModelChange)="onValueChange($event, FFIndex, compindex)">
                                </cxone-singleselect-dropdown>
                            </div>

                            <cxone-numeric-selector [ngModel]="selection.ValueList[compindex].name"
                                (ngModelChange)="onValueChange($event, FFIndex, compindex)"
                                *ngIf="selection.DataField?.ExpectedType == 1 || selection.DataField?.ExpectedType == 2"></cxone-numeric-selector>
                            <cxone-combined-datetime-picker style="width: 49%"
                                [datetimePickerContainer]="'cv-filter-fields-edit'" [timeFormat]="'h:mm A'"
                                [shortDateTimeFormat]="'MMM D, YYYY h:mm A'" [mode]="'page'"
                                [ngModel]="selection.ValueList[compindex].name"
                                (ngModelChange)="onValueChange($event, FFIndex, compindex)"
                                *ngIf="selection.DataField?.ExpectedType == 3"></cxone-combined-datetime-picker>
                            <div *ngIf="selection.DataField?.ExpectedType == 4" class="d-flex">
                                <cxone-radio ngDefaultControl [ngModel]="selection.ValueList[compindex].name"
                                    [labelText]="trueText" [value]="'true'" [name]="compindex + 'boolValue' + FFIndex"
                                    (ngModelChange)="onValueChange($event, FFIndex, compindex)"></cxone-radio>
                                <cxone-radio ngDefaultControl [ngModel]="selection.ValueList[compindex].name"
                                    [labelText]="falseText" [value]="'false'" [name]="compindex + 'boolValue' + FFIndex"
                                    style="margin-left: 16px;"
                                    (ngModelChange)="onValueChange($event, FFIndex, compindex)"></cxone-radio>
                            </div>
                            <span *ngIf="selection.DataField?.ExpectedType != 4" class="value-icon cursor-hover"
                                (click)="deleteValue(FFIndex, compindex)"><svg class="icon-16"
                                    [ngClass]="{'value-icon-disabled': selection.ValueList.length == 1}">
                                    <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                                </svg></span>
                            <span *ngIf="last && selection.DataField?.ExpectedType != 4" class="value-icon cursor-hover"
                                (click)="addValue(FFIndex)"><svg class="icon-16">
                                    <use href="../App_Themes/CXone/icons/add.svg#add"></use>
                                </svg></span>

                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="cxone-btn btn-medium btn-secondary btn-bg-is-white" cvLocalizedText
        langSection="Common" langKey="Cancel_Button" (click)="cancelClick()">Cancel</button>
    <button type="button" (click)="AddClick()"
        [disabled]="!areFilterFieldsValid()"
        class="cxone-btn btn-medium btn-primary add-button-override" cvLocalizedText langSection="Common"
        langKey="Add">Add</button>
</div>